// Upload constraints
export const UPLOAD_CONSTRAINTS = {
  MAX_FILE_SIZE: 200 * 1024 * 1024, // 200MB
  ALLOWED_MIME_TYPES: [
    'text/plain',
    'text/csv',
    'application/csv',
    'application/vnd.ms-excel',
    'application/x-csv',
    'text/comma-separated-values',
    '', // Many browsers don't set MIME type for .csv files
  ],
  ALLOWED_EXTENSIONS: ['.txt', '.csv', '.tsv'],
  MAX_PASTE_LENGTH: 500000, // 500KB
};

// Validation helpers
export function validateFile(file: File): { valid: boolean; error?: string } {
  if (!file) {
    return { valid: false, error: 'No file provided' };
  }

  if (file.size > UPLOAD_CONSTRAINTS.MAX_FILE_SIZE) {
    return {
      valid: false,
      error: `File size exceeds ${UPLOAD_CONSTRAINTS.MAX_FILE_SIZE / 1024 / 1024}MB limit`,
    };
  }

  // Check file extension first, then MIME type
  const ext = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
  const hasValidExt = UPLOAD_CONSTRAINTS.ALLOWED_EXTENSIONS.includes(ext);
  const hasValidMimeType = UPLOAD_CONSTRAINTS.ALLOWED_MIME_TYPES.includes(file.type);

  if (!hasValidExt && !hasValidMimeType) {
    return {
      valid: false,
      error: `File type not allowed. Please use .txt, .csv, or .tsv files.`,
    };
  }

  return { valid: true };
}

export function validatePastedText(text: string): { valid: boolean; error?: string } {
  if (!text) {
    return { valid: false, error: 'No text provided' };
  }

  if (text.length > UPLOAD_CONSTRAINTS.MAX_PASTE_LENGTH) {
    return {
      valid: false,
      error: `Pasted text exceeds ${UPLOAD_CONSTRAINTS.MAX_PASTE_LENGTH / 1024}KB limit`,
    };
  }

  return { valid: true };
}
